import React from 'react'

function FavoriteDetailsPage() {
  return (
    <div>FavoriteDetailsPage</div>
  )
}

export default FavoriteDetailsPage